// ABOUTME: Splits a polling origin's config flows into the viewed operator's own and other operators' on a shared source
import { Config } from '../../api/adminApi';

// Splits a polling origin's flows into those the viewed operator owns and those
// belonging to other operators sharing the same source. Disabling the origin
// stops both, so the others surface (read-only) for awareness. Ownership is the
// server-resolved techlogOperatorId on each config.
export function partitionConfigsByOperator(
  configs: Config[],
  operatorId: string,
): { mine: Config[]; others: Config[] } {
  const mine: Config[] = [];
  const others: Config[] = [];
  for (const config of configs) {
    if (config.techlogOperatorId === operatorId) mine.push(config);
    else others.push(config);
  }
  return { mine, others };
}

export const byDestination = (a: Config, b: Config) =>
  a.destination.localeCompare(b.destination);
